// src/context/ChatContext.jsx
import React, { createContext, useState } from 'react';

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [chatDictionary, setChatDictionary] = useState({});

  return (
    <ChatContext.Provider value={{ chatDictionary, setChatDictionary }}>
      {children}
    </ChatContext.Provider>
  );
};